"use strict";

/**
 * Bietet einen zentralen Cache für Underscore Templates + Helfer (globale Variablen/Funktionen).
 */

var _ = require('underscore');
var Backbone = require('backbone');


var TemplateCache = function() {
	_.extend(this, Backbone.Events);

	/* Globale Helferfunktionen */
	this.helpers = {};

	/* Kompilierte Templates */
	this.cache = {};

	/* Registrierte Funktionen zum Laden von Templates. { name: func(ident) } */
	this.loaders = {};

	/* Verwendungsreihenfolge der Loader. Nicht-definierte Loader werden ignoriert.*/
	this.loadersOrder = ['dom', 'jst', 'webpack'];

	/* Gesamtzeit die fürs Kompiling verwendet wurde (Sekunden) */
	this.compileTime = 0.0;

	/* Gesamtzeit die fürs Rendering verwendet wurde (Sekunden) */
	this.renderTime = 0.0;

	_.bindAll(this, "helper", "clear", "render", "errorFunc");
};


/**
 * Eine Lade-Funktion registrieren. Ermöglicht das Laden von Templates von verschiedenen
 * Quellen, etwa dem DOM oder vorkompilierten Templates.
 *
 * @param loader {Function} Erhält den Ident als ersten Parameter und muss einen String oder null zurückgeben.
 */
TemplateCache.prototype.registerLoader = function(name, loader) {
	this.loaders[name] = loader;
};


/**
 * Ein Template laden und mit Daten rendern.
 * Kompilierte Templates werden zwischengespeichert, bis clear() aufgerufen wird.
 *
 * @param ident {String} ID des Templates im DOM
 * @param data {Object} Zu rendernde Daten
 */
TemplateCache.prototype.render = function(ident, data) {
	/* Templates können auch ohne Daten gerendet werden, etwa Loading-Indicators */
	var template = this._get(ident);

	var start = new Date();
	var result = typeof data === "undefined" ? template() : template(data);

	this.renderTime += ( (new Date()) - start ) / 1000;
	this.trigger("render", ident, data, result);
	this.trigger("render:" + ident, ident, data, result);
	return result;
};


TemplateCache.prototype._get = function(ident) {
	if ( typeof this.cache[ident] === "undefined" ) {
		var template = null;

		for(let i = 0, loaderName; loaderName = this.loadersOrder[i]; ++i) {
			let loader = this.loaders[loaderName];
			if ( !loader ) continue;

			let loaded_template = loader(ident);
			//console.log("[TemplateCache] " + ident + ": " + loaderName + " => " + (typeof loaded_template));
			if ( loaded_template ) {
				template = loaded_template;
				break;
			}
		}

		if ( template === null ) {
			return this.errorFunc("No loader returned a template for " + ident);
		}

		try {
			this.cache[ident] = this._compile(ident, template);	
		}
		catch (e) {
			return this.errorFunc("Failed to compile template " + ident, e);
		}
	}
	return this.cache[ident];
};


TemplateCache.prototype._compile = function(ident, template) {
	var timer = require('MiniTimer')("Compile: " + ident);

	if ( typeof template === "string" ) {
		console.warn("Compiling a JS template: " + ident);
		template = _.template( template );
	}

	var wrappedTemplate = function( data ) {
		data = _.defaults({}, data, this.helpers);
		try {
			return template.call( this, data );
		}
		catch (e) {
			return this.errorFunc("Render Error in Template" + ident, e)();
		}
	}.bind(this);
	
	this.compileTime += timer();
	return wrappedTemplate;
};


/**
 * Gibt eine Funktion zurück, die eine Fehlermeldung als String zurück gibt.
 * Wird verwendet, wenn es Probleme mit Templates gibt.
 * Dies verhindert, dass Apps an zufälligen Stellen abstürzen.
 */
TemplateCache.prototype.errorFunc = function(message, e) {
	if ( typeof e !== "undefined" ) {
		message += "<br>" + e.toString();
	}
	return function() {
		if ( typeof Raven !== "undefined" ) Raven.captureMessage("TemplateCache: " + message.replace('<br>', ' '));
		return '<div class="template-error"><b>[TemplateCache ERROR]</b> ' + message + '</div>';
	}
};


/**
 * Eine globale Helfer-Funktion für Templates registrieren
 *
 * @param name {String} Name des Helfers
 * @param name {Function} Aufzurufende Funktion
 */
TemplateCache.prototype.helper = function(name, func) {
	this.helpers[name] = func;
};


/**
 * Alle gecachten Templates entfernen.
 */
TemplateCache.prototype.clear = function() {
	this.cache = {};
};


/* Singleton erzeugen */
var singleton = new TemplateCache();

/**
 * Loader um Templates aus dem DOM zu holen. Primär für die Entwicklung verwendet.
 */
singleton.registerLoader("dom", function(ident) {
	var node = document.getElementById(ident);
	if ( node ) return node.innerHTML;
});

/**
 * Loader um Templates aus window.JST zu holen. Wird später für Template Resources gebraucht.
 */
singleton.registerLoader("jst", function(ident) {
	if ( window.JST && typeof window.JST[ident] === "function" ) {
		return window.JST[ident];
	}
});

module.exports = singleton;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/TemplateCache.js
 **/